<template>
  <div class="body">
      <Head></Head>
      <img src="../../static/img/products.jpg" alt="">
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Products' }">产品库</el-breadcrumb-item>
            <el-breadcrumb-item>{{info.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="ProdCont-top" v-loading="loading">
          <!-- 左边 -->
          <div class="ProdCont-top-left">
            <el-carousel  height="274px" arrow="never">
              <!-- <el-carousel-item v-for="item in 4" :key="item"> -->
                <video v-if="info.sp"
                     v-bind:src="info.sp"
                     class="video-avatar sp-w"
                     controls="controls"
                     style="width: 390px; height: 274px">
                  您的浏览器不支持视频播放
                </video>


                <el-image  v-else :src="info.picurl" alt="" style="width: 390px; height: 274px" lazy> </el-image>
              <!-- </el-carousel-item> -->
            </el-carousel>
          </div>
          <!-- 中间 -->
          <div class="ProdCont-top-center">
              <p class="ProdCont-top-center-title "><a>{{info.title}}</a><span v-if="info.is_top==1"><img src="../../static/img/zj.png" alt=""></span></p>
              <div class="ProdCont-top-center-tel">
                <div class="ProdCont-top-center-tel-left">
                  <p>产品请致电咨询：</p>
                  <p><img src="../../static/img/indextel.png" alt="">{{infoqiye.kftel}}</p>
                </div>
                <div class="ProdCont-top-center-tel-right" v-if="userid>0">
                    <!-- <i class="el-icon-star-off" ></i> -->
                    <i class="el-icon-star-on" v-if="info.sc > 0"  @click="sc(info.id,1)">取消收藏</i>
                    <i class="el-icon-star-off"  @click="sc(info.id,0)" v-else>加入收藏</i>

                    <el-popover
                      placement="right"
                      :v-model="false"
                      width="120"
                      trigger="click">
                      <div id="qrcode"  />
                      <div slot="reference" class="div-fx"><img src="/static/img/wx.png" alt="">微信分享</div>
                      <!-- <el-button slot="reference">click 激活</el-button> -->
                    </el-popover>


                </div>
              </div>
              <div class="ProdCont-top-center-jianjie ov2">产品简介:{{info.introduction}}</div>
              <div class="ProdCont-top-center-but">
                <el-button @click="dialogFormVisible = true">产品咨询</el-button>
                <el-button @click="dialogFormVisiblezj = true">专家帮我挑</el-button>
              </div>
          </div>
          <!-- 右边 -->
          <div class="ProdCont-top-right">
              <img :src="infoqiye.imageLogos" alt="">
              <p class="ProdCont-top-right-title">{{infoqiye.title}}</p>
              <p class="xian"></p>
              <p class="ProdCont-top-right-tel ov1">所在地区：{{infoqiye.addressdq}}</p>
              <p class="ProdCont-top-right-tel ov1">主营行业：{{infoqiye.zyhy}}</p>
              <p class="xian"></p>
              <div class="ProdCont-top-center-but">
                <el-button @click="$router.push('/CompanyAbout?id='+infoqiye.id+'')">进入店铺</el-button>
              </div>
          </div>
          <div class=""></div>
          <div class="clear"></div>
        </div>
        <div class="h-30"></div>
        <!-- 左侧开始 -->
         <div id="products-right" class="left">
             <p class="products-right-title">软件系统</p>
             <ul class="products-right-ul">
               <li class="ov1">
                 <router-link :to="{path:'/CompanyAbout',query: {id: infoqiye.id}}">
                    全部（{{count}}）
                </router-link>
               </li>
             </ul>
         </div>

         <div class="w-products rihgt products-content-right-s" v-loading="loading">
            <el-tabs v-model="activeName" >
                <el-tab-pane label="产品详情" name="first">
                  <div class="content">
                    <div  v-html="info.content"></div>
                  </div>
                </el-tab-pane>
                <el-tab-pane :label="'产品评价（'+total+'）'" name="second">
                    <ul class="products-content-pjlist content">
                      <li  v-for="(item, index) in list" :key="item.id">
                        <div class="products-content-pjlist-left">
                            <img :src="item.headimgurls" alt="" v-if="item.headimgurls" >
                            <img src="../../static/img/indextj3.jpg" alt=""  v-else  />
                            <p>{{item.username}}</p>
                        </div>
                        <div class="products-content-pjlist-right">
                          <p><span class="zj">#{{item.text}}# </span>{{item.content}}</p>
                          <!-- <img src="../../static/img/banner.jpg" alt="" class="products-content-pjlist-right-img"> -->
                          <p class="products-content-pjlist-time">{{item.create_time}}</p>
                        </div>
                        <div class="clear"></div>
                      </li>

                    </ul>
                    <div class="page">
                      <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="12"
                        @current-change="handleCurrentChange"
                        :total="total">
                      </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="我要评价" name="third">
                  <div class="content">
                    <el-input
                      class="textarea-ipt"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 6}"
                      placeholder="请填写您的评价"
                      v-model="content">
                    </el-input>
                    <div class="h-10"></div>
                   <!-- <el-upload
                      class="upload-demo"
                      action="/Upload/uploadcords"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :file-list="fileList"
                      list-type="picture">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload> -->
                    <div class="ProdCont-top-center-but" style="width: 27%;">
                      <el-button @click="buttonpj(info.id)">提交评价</el-button>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
         </div>
        <!-- 右侧结束 -->
      </div>
      <el-dialog title="产品咨询" :visible.sync="dialogFormVisible">
          <Productzx :productid='info.id' :title='info.title'  @handleClose="handleClose"></Productzx>
      </el-dialog>

      <el-dialog title="专家帮我挑" :visible.sync="dialogFormVisiblezj" >
          <Productzj :productid='info.id' :title='info.title' @handleClosezj="handleClosezj"></Productzj>
      </el-dialog>
      <div class="h-30 clear"></div>
      <Foot></Foot>
  </div>

</template>

<script>
import QRCode from 'qrcode2';
// this.showErCodePopup = true;//生成弹窗

import head from '@/components/public/head.vue';
import foot from '@/components/public/foot.vue'
import productzx from '@/components/public/productzx.vue'
import productzj from '@/components/public/productzj.vue'
export default{
  data(){
    return {
      loading:true,
      dialogFormVisible: false,
      dialogFormVisiblezj: false,
      list:{},
      page:1,
      total:0,
      type:{},
      count:'',
      infoqiye:{},
      id:'',
      info:{
        picurl:'',
      },
      ptzc:'',
      tabPosition:'1',
      activeName: 'first',
      content:'',
      userid:0,
      fileList: [
        {name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'},
        {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'},
      ]
    }
  },
  components: {
    'Head': head,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Productzx':productzx,
    'Productzj':productzj,


  },
  mounted () {

    this.id = this.$route.query.id;
    setTimeout(() => {
    	let shareUrl = "http://touch.zyjlfwpt.com/ProductsCont?id="+this.id;
    	let qrcode = new QRCode("qrcode", {
    	  text: shareUrl,
    	  width: 120, //图像宽度
    	  height: 120, //图像高度
    	});
    qrcode.clear(); //清除二维码
    	 qrcode.makeCode(shareUrl); //生成另一个新的二维码
      }, 100);
    console.log(this.id);
    this.recordapi();
  },

  methods:{

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        if(userid>0){
          that.userid = userid;
        }
        that.$api.post("/Products/ProductsCont",{'id':that.id,'page':this.page,'userid':userid}).then(res => {
          console.log(res);
          that.info= res.info;
          that.count= res.count;
          that.infoqiye = res.infoqiye;
          that.list= res.list.data;
          this.total = res.list.total
          this.loading = false
        });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
    // 收藏
    sc(e,zt){
      var that = this;
      var id = e;
      var zt = zt;
      console.log(zt);
      var userid = that.$cookieStore.getCookie('userid');
      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      that.$api.post("/Products/ProductsSc",{'id':id,'userid':userid,zt:zt}).then(res => {
        console.log(res);
        if(res.code==1){
          if(zt==1){
            that.info.sc = 0;
          }else{
            that.info.sc = 1;
          }
          this.$message.success(res.msg);
        }

      });

    },
    buttonpj(e){
      var that = this;
      if(that.content == ''){
        this.$message.error('请填写评价内容');
        return;
      }
      var id = e;
      var userid = that.$cookieStore.getCookie('userid');
      if(userid==''){
        this.$message.error('请先登录');
        return;
      }
      that.$api.post("/Products/ProductsPj",{'id':id,'userid':userid,'content':that.content}).then(res => {
        console.log(res);
        if(res.code==1){
          that.content ='';
          this.$message.success(res.msg);
        }

      });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogFormVisible = false
    },
    // 关闭弹窗
    handleClosezj(){
      this.dialogFormVisiblezj = false
    },


    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
     console.log(file);
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/ProductsCont.vue